export default "__VITE_ASSET__b809d4cc__"